document.addEventListener("DOMContentLoaded", function () {
    const filterForm = document.getElementById('agency__filter-form');
    if (!filterForm) return;

    const listContainer = document.getElementById('agency__list-container');
    const searchInput = document.getElementById('filter-q');
    const countrySelect = document.getElementById('filter-country');
    const memberCheckbox = filterForm.querySelector('input[name="member"]');

    let debounceTimer;

    const updateList = async (pushState = true) => {
        const formData = new FormData(filterForm);
        const params = new URLSearchParams(formData);

        // Remove empty values from URL
        if (!params.get('q')) params.delete('q');
        if (!params.get('country')) params.delete('country');
        if (!params.get('member')) params.delete('member');

        const queryString = params.toString();
        const url = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;

        if (pushState) {
            window.history.pushState({ queryString }, '', url);
        }

        // Add loading state
        listContainer.classList.add('is-loading');

        try {
            const response = await fetch(url, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const html = await response.text();
            listContainer.innerHTML = html;

            // Re-attach event listener for reset button if it exists in the new HTML
            attachResetListener();
        } catch (error) {
            console.error('Error fetching filtered list:', error);
        } finally {
            listContainer.classList.remove('is-loading');
        }
    };

    const attachResetListener = () => {
        const resetBtn = document.getElementById('reset-filters');
        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                if (searchInput) searchInput.value = '';
                if (countrySelect) countrySelect.value = '';
                if (memberCheckbox) memberCheckbox.checked = false;
                updateList();
            });
        }
    };

    if (searchInput) {
        searchInput.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(updateList, 300);
        });
    }

    if (countrySelect) {
        countrySelect.addEventListener('change', updateList);
    }

    if (memberCheckbox) {
        memberCheckbox.addEventListener('change', updateList);
    }

    // Initial attach for reset button
    attachResetListener();

    // Handle browser back/forward
    window.addEventListener('popstate', (event) => {
        const params = new URLSearchParams(window.location.search);

        // Sync form fields with URL
        if (searchInput) searchInput.value = params.get('q') || '';
        if (countrySelect) countrySelect.value = params.get('country') || '';
        if (memberCheckbox) memberCheckbox.checked = params.get('member') === '1';

        updateList(false);
    });
});
